import Model from "@/components/common/model.component";
import Form from "@/components/common/form/form";
import Input from "@/components/common/form/input";
import Button from "@/components/common/form/button";
import { AddLocationService } from "services/addLocatinValve.service";
import { useSelector } from "react-redux";
import _objI from "@/utils/_objI";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import PageTitle from "components/common/page-title.component";

type Reducer = {
  valveDataReducer?: any;
};
function locationModal({
  refresh,
  showModal,
  setShowModal,
  closeMainModal,
  rowData,
}) {
  const { t } = useTranslation();

  const schema = yup.object({
    long: yup.number().required("Long Is Required Field"),
    lat: yup.number().required("Lat Code Is Required Field"),
  });
  const onSubmit = async (data) => {
    let subData = {
      geometry: {
        type: "Point",
        coordinates: [Number(data.lat), Number(data.long)],
      },
      entity_type_id: rowData?.rowData?.entity_type_id,
    };

    if (rowData.rowData.gboundary_id) {
      let res = await AddLocationService.editLocation(
        subData,
        rowData?.rowData?.gboundary_id
      );
      if (res) {
        setShowModal(false);
        closeMainModal(false);
        refresh(1);
      }
    }
  };
  return (
    _objI(rowData) && (
      <>
        <Model
          width="w-96"
          show={showModal}
          onClose={(e) => {
            setShowModal(false);
          }}
        >
          <PageTitle title={t("Edit_Location_Info")} titletextSize="text-xl" />

          <Form
            defaultValues={{
              lat: rowData?.rowData?.location?.coordinates?.[0],
              long: rowData?.rowData?.location?.coordinates?.[1],
            }}
            onSubmit={onSubmit}
            schema={schema}
          >
            <div className="flex gap-2">
              <Input name="lat" label={t("Lat")} />
              <Input name="long" label={t("Long")} />
            </div>

            <Button
              title={t("Save")}
              className="w-full h-[35px] text-white rounded-lg bg-main  text-md mt-5"
            />
          </Form>
        </Model>
      </>
    )
  );
}

export default locationModal;
